import { connect } from 'react-redux';
import StrukturUnitPusat from '../../views/Settings/StrukturUnitPusat.view';
import {
  getParamOptionsAcademics, getStudentOptions, getPeriodsOptions, getSchoolUnitsOptions,
   getSchoolUnitsManageOptions, getPrmPositionOption, getPrmPositionAdmOption, getPrmStaffMasterID
} from '../../states/thunks/options.thunk';
import { getDetailsPosition, updateDetailsPosition, postingPosition, addDetailsPosition, deleteDetailsPosition } from '../../states/thunks/academics.thunk';

function mapStateToProps(state) {
  return {
    result: state.result,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    getStudentOptions: payload => dispatch(getStudentOptions(payload)),
    getPrmPositionOption: payload => dispatch(getPrmPositionOption(payload)),
    getPrmPositionAdmOption: payload => dispatch(getPrmPositionAdmOption(payload)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
    handleGetDetailsPosition: (payload, goback) => dispatch(getDetailsPosition(payload, goback)),
    handleAddDetailsPosition: (payload, goback) => dispatch(addDetailsPosition(payload, goback)),
    handleUpdateDetailsPosition: (payload, goback) => dispatch(updateDetailsPosition(payload, goback)),
    handlePostingPosition: (payload, goback) => dispatch(postingPosition(payload, goback)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    getSchoolUnitsManageOptions: payload => dispatch(getSchoolUnitsManageOptions(payload)),
    getPrmStaffMasterIDOptions: payload => dispatch(getPrmStaffMasterID(payload)),
    handleDeleteDetailsPosition: (payload, goback) => dispatch(deleteDetailsPosition(payload, goback)),
    

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StrukturUnitPusat);
